import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
import intl from 'i18n/intl';
import {
  getDataSource,
  reportSourceTypeDataSource,
  reportSourceTypeLoading,
} from 'slices/appsReportSourceType';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import ConfigurationItem from './ConfigurationItem';
import './DataSourceTypes.scss';

const language: any = intl.messages;

const CONFIGURATIONS = [
  {
    title: 'Schedule generator',
    placeholder: 'No other product requirements',
    field: 'SCHEDULE_GENERATOR',
  },
  {
    title: 'Reservations',
    placeholder: 'No other product requirements',
    field: 'RESERVATIONS',
  },
  {
    title: 'Orders',
    placeholder: 'Requires TE Plan',
    field: 'ORDERS',
  },
  {
    title: 'Exams',
    placeholder: 'Requires TE Exam',
    field: 'EXAMS',
  },
  {
    title: 'Forms',
    placeholder: 'Requires TE Preferences',
    field: 'FORMS',
  },
  {
    title: 'Activities',
    placeholder: 'Requires TE Preferences',
    field: 'ACTIVITIES',
  },
];

const DataSourceTypes = () => {
  const dispatch = useAppDispatch();
  const dataSource = useSelector(reportSourceTypeDataSource);
  const loading = useSelector(reportSourceTypeLoading);

  useEffect(() => {
    dispatch(getDataSource());
  }, [dispatch]);

  return (
    <DefaultContentLayout
      title={language.report_settings}
      subtitle={language.manage_data_source_types}
    >
      <LoadingWrapper isLoading={loading}>
        <div className="report-configuration" style={{ padding: '15px' }}>
          {CONFIGURATIONS.map((item) => (
            <ConfigurationItem
              value={dataSource[item.field]}
              key={item.field + dataSource[item.field]}
              field={item.field}
              placeholder={item.placeholder}
              title={item.title}
            />
          ))}
        </div>
      </LoadingWrapper>
    </DefaultContentLayout>
  );
};

export default DataSourceTypes;
